import React from "react";
import { Typography } from "antd";

import colors from "../styles/globalColors";
const { Title: ATitle } = Typography;

export default (props: { children: any }) => {
  const { children } = props;
  return (
    <ATitle
      level={3}
      style={{
        color: colors.black,
        fontWeight: 300,
        marginTop: 0,
        marginBottom: 30
      }}
    >
      {children}
    </ATitle>
  );
};
